import React, { useRef } from "react";

const DobInput = ({
  value,
  onChange,
  invalid = false,
  label = "DOB",
  required = true,
  labelPosition = "left", // "top" | "left"
}) => {
  const isTop = labelPosition === "top";
  const monthRef = useRef(null);
  const dayRef = useRef(null);
  const yearRef = useRef(null);

  const handleMonthChange = (e) => {
    let month = e.target.value.slice(0, 2);
    if (month.length === 2 && parseInt(month) <= 12) {
      dayRef.current?.focus();
    }
    updateDate(month, getDayFromValue(), getYearFromValue());
  };

  const handleDayChange = (e) => {
    let day = e.target.value.slice(0, 2);
    if (day.length === 2 && parseInt(day) <= 31) {
      yearRef.current?.focus();
    }
    updateDate(getMonthFromValue(), day, getYearFromValue());
  };

  const handleYearChange = (e) => {
    let year = e.target.value.slice(0, 4);
    updateDate(getMonthFromValue(), getDayFromValue(), year);
  };

  const getMonthFromValue = () => value?.split("/")?.[0] || "";
  const getDayFromValue = () => value?.split("/")?.[1] || "";
  const getYearFromValue = () => value?.split("/")?.[2] || "";

  const updateDate = (month, day, year) => {
    const formattedDate = [month, day, year].filter(Boolean).join("/");
    onChange(formattedDate);
  };

  return (
    <div
      className={`w-full mb-4 ${
        isTop
          ? "flex flex-col gap-2"
          : "flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4"
      }`}
    >
      <label
        htmlFor="dob-month"
        className={`text-base font-medium text-black ${
          isTop ? "" : "sm:whitespace-nowrap"
        }`}
      >
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>

      <div className="flex gap-2 items-center w-full sm:w-auto">
        <div className="flex-1 sm:flex-none">
          <input
            ref={monthRef}
            type="text"
            id="dob-month"
            inputMode="numeric"
            placeholder="MM"
            maxLength="2"
            value={getMonthFromValue()}
            onChange={handleMonthChange}
            className={`text-black text-center w-full sm:w-12 px-2 py-2 bg-slate-50 border-0 border-b-2 rounded-md shadow-sm
              ${invalid ? "border-b-red-500" : "border-b-gray-300"}
              focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 font-medium
            `}
          />
        </div>
        <span className="text-gray-400">/</span>
        <div className="flex-1 sm:flex-none">
          <input
            ref={dayRef}
            type="text"
            id="dob-day"
            inputMode="numeric"
            placeholder="DD"
            maxLength="2"
            value={getDayFromValue()}
            onChange={handleDayChange}
            className={`text-black text-center w-full sm:w-12 px-2 py-2 bg-slate-50 border-0 border-b-2 rounded-md shadow-sm
              ${invalid ? "border-b-red-500" : "border-b-gray-300"}
              focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 font-medium
            `}
          />
        </div>
        <span className="text-gray-400">/</span>
        <div className="flex-1 sm:flex-none">
          <input
            ref={yearRef}
            type="text"
            id="dob-year"
            inputMode="numeric"
            placeholder="YYYY"
            maxLength="4"
            value={getYearFromValue()}
            onChange={handleYearChange}
            className={`text-black text-center w-full sm:w-16 px-2 py-2 bg-slate-50 border-0 border-b-2 rounded-md shadow-sm
              ${invalid ? "border-b-red-500" : "border-b-gray-300"}
              focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 font-medium
            `}
          />
        </div>
      </div>
    </div>
  );
};

export default DobInput;
